"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateDatasetsListItem = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2020 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var util_1 = require("@gooddata/util");
var ShortenedText_1 = require("../ShortenedText");
/**
 * @internal
 */
exports.DateDatasetsListItem = function (_a) {
    var id = _a.id, title = _a.title, isHeader = _a.isHeader, isSelected = _a.isSelected, isUnrelated = _a.isUnrelated, onClick = _a.onClick;
    if (isHeader) {
        return (react_1.default.createElement("div", { className: "gd-list-item gd-list-item-header" },
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: title })));
    }
    var classNames = classnames_1.default("gd-list-item", "gd-list-item-shortened", "s-" + id, "s-" + util_1.stringUtils.simplifyText(title), {
        "is-selected": isSelected,
        "is-unrelated": isUnrelated,
    });
    var tooltipAlignPoints = [
        { align: "cl cr", offset: { x: -10, y: 0 } },
        { align: "cr cl", offset: { x: 10, y: 0 } },
    ];
    return (react_1.default.createElement("div", { className: classNames, onClick: onClick },
        react_1.default.createElement(ShortenedText_1.ShortenedText, { tooltipAlignPoints: tooltipAlignPoints }, title)));
};
//# sourceMappingURL=DateDatasetsListItem.js.map